import { 
    GET_PROFILE, 
    GET_PROFILE_SUCCESS, 
    GET_PROFILE_ERROR,

    UPDATE_PROFILE,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_ERROR

} from "./actionTypes";

export const getProfile = () => ({
  type: GET_PROFILE,
});

export const getProfileSuccess = (profile) => ({
  type: GET_PROFILE_SUCCESS,
  payload: profile,
});

export const getProfileError = (error) => ({
  type: GET_PROFILE_ERROR,
  payload: error,
});


export const updateProfile = (values) => ({
  type: UPDATE_PROFILE,
  payload: values,
});

export const updateProfileSuccess = (profile) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: profile,
});

export const updateProfileError = (error) => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
});